var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyFavoritesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.964 8C264.887 8 273.035 13.0921 276.914 21.1134L343.451 158.145L492.141 180.162C500.871 181.423 508.048 187.533 510.861 195.875C513.577 204.313 511.346 213.527 505.138 219.638L397.282 326.524L422.791 477.348C424.246 486.077 420.658 495 413.383 500.141C406.206 505.281 395.827 505.96 388.844 501.79L255.964 430.791L122.308 501.79C115.325 505.96 105.819 505.281 98.5449 500.141C91.3675 495 87.7787 486.077 88.3607 477.348L114.646 326.524L6.89654 219.638C0.630817 213.527 -1.59032 204.313 1.16428 195.875C3.90917 187.533 11.1545 181.423 19.8742 180.162L168.477 158.145L235.014 21.1134C238.99 13.0911 247.041 8 255.964 8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyFavoritesActive);
export default __webpack_public_path__ + "static/media/my-favorites-active.b70a14fa31ed9686bbccf9151383fdcb.svg";
export { ForwardRef as ReactComponent };